import CryptoJS from 'crypto-js';
import { postApi, handleStoreApiError } from '../../lib/fetcher';
import { btoa, atob } from '../../lib/helpers';

const mccmdr = {
  namespaced: true,

  state() {
    return {
      allData: [],
      totalData: 0,
      loading: false,
      cacheData: {},
      errors: [],
      flashErrorMessage: '',
      flashError: false,
      allCategory: [],
      totalPage: 0,
    };
  },

  mutations: {
    setData(state, { payload }) {
      state.allData = payload.data.list;
    },

    setCategory(state, data) {
      state.allCategory = data;
    },

    setFlashErrorMessage(state, payload) {
      state.flashErrorMessage = payload;
      state.flashError = payload !== '';
    },

    clearData(state) {
      state.allData = [];
      state.totalData = 0;
    },

    clearErrors(state) {
      state.errors = [];
    },

    clearErrorVariable(state, variable) {
      state.errors[variable] = [];
    },

    setErrors(state, payload) {
      state.errors = payload;
    },

    setTotalData(state, { payload }) {
      state.totalData = parseInt(payload.data.countdata, 10);
      state.totalPage = parseInt(payload.data.totalPage, 10);
    },

    setLoading(state, loading) {
      state.loading = loading;
    },

    removeSingleData(state, { index }) {
      state.totalData -= 1;
      state.allData = state.allData.filter((value) => value.mcc !== index);
    },

    addData(state) {
      state.totalData += 1;
    },

    pushData(state, { payload }) {
      state.allData.push(payload);
    },

    editData(state, { payload, index }) {
      Object.assign(state.allData[index], payload);
    },
  },

  actions: {
    fetchAllCategory(ctx) {
      ctx.commit('setCategory', [
        {
          id: '1',
          name: 'Reguler',
        },
        {
          id: '2',
          name: 'Khusus',
        },
      ]);
    },

    async getData(ctx, { date, page, itemsPerPage, sortBy, sortDesc, search }) {
      ctx.commit('clearData');
      ctx.commit('setLoading', true);
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      const sortByField = `${sortBy[0] ? sortBy[0] : 'mcc'} ${sort}`;

      const data = JSON.stringify({
        search,
        sort_by: sortByField,
        limit: itemsPerPage.toString(),
        page: page.toString(),
        version: btoa(
          CryptoJS.SHA256(
            page.toString() +
              itemsPerPage.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });
      const urlApi = `/index.php?r=api/v1/setting-fee/jenis-usaha/index`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData) {
        ctx.commit('setTotalData', {
          payload: responseData,
        });
        ctx.commit('setData', { payload: responseData });
      }
    },

    async createData(ctx, { date, value }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        mcc: value.mcc,
        description: value.description,
        category_id: value.category_id,
        mcc_name: value.mcc_name,
        mdr_on_us: value.mdr_on_us,
        mdr_off_us: value.mdr_off_us,
        status: value.status,
        version: btoa(
          CryptoJS.SHA256(
            value.mcc +
              value.description +
              value.category_id +
              value.mcc_name +
              value.mdr_on_us +
              value.mdr_off_us +
              value.status +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/setting-fee/jenis-usaha/create`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code === 302) {
        ctx.commit('setLoading', false);
        return { success: false, ...responseData };
      }

      if (responseData?.code !== 200) {
        handleStoreApiError(ctx, responseData);
        ctx.commit('setLoading', false);
        return { success: false, ...responseData };
      }
      ctx.commit('pushData', {
        payload: responseData.data.data,
      });
      ctx.commit('addData');
      ctx.commit('clearErrors');
      ctx.commit('setLoading', false);

      return { success: true, shouldRefresh: true };
    },

    async updateData(ctx, { date, body, index }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        id: body.id,
        mcc: body.mcc,
        description: body.description,
        category_id: body.category_id,
        mcc_name: body.mcc_name,
        mdr_on_us: body.mdr_on_us,
        mdr_off_us: body.mdr_off_us,
        status: body.status,
        version: btoa(
          CryptoJS.SHA256(
            body.id +
              body.mcc +
              body.description +
              body.category_id +
              body.mcc_name +
              body.mdr_on_us +
              body.mdr_off_us +
              body.status +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });
      const urlApi = `/index.php?r=api/v1/setting-fee/jenis-usaha/update`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code === 302) {
        ctx.commit('setLoading', false);
        return { success: false, ...responseData };
      }

      if (responseData?.code !== 200) {
        handleStoreApiError(ctx, responseData);
        ctx.commit('setLoading', false);
        return { success: false, ...responseData };
      }
      ctx.commit('editData', {
        payload: responseData.data.data,
        index,
      });
      ctx.commit('clearErrors');
      ctx.commit('setLoading', false);

      return { success: true };
    },

    async deleteData(ctx, { date, body, index }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        mcc: body.mcc.toString(),
        version: btoa(
          CryptoJS.SHA256(
            body.mcc.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/setting-fee/jenis-usaha/deactivated`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code !== 200) {
        handleStoreApiError(ctx, responseData);
        ctx.commit('setLoading', false);
        return false;
      }
      ctx.commit('editData', {
        payload: { ...body, status: '0' },
        index,
      });
      ctx.commit('setLoading', false);

      return true;
    },
  },
};

export default mccmdr;
